
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Mail, Database, CreditCard, ShoppingBag, Users } from 'lucide-react';

interface IntegrationCategory {
  title: string;
  icon: React.ReactNode;
  integrations: Array<{
    name: string;
    logo: string;
  }>;
}

const integrationCategories: IntegrationCategory[] = [
  {
    title: "CRM Integrations",
    icon: <Users className="h-6 w-6 text-primary-blue" />,
    integrations: [
      { name: "HubSpot", logo: "/integrations/hubspot.png" },
      { name: "Zoho CRM", logo: "/integrations/zoho.png" },
    ]
  },
  {
    title: "Email Marketing",
    icon: <Mail className="h-6 w-6 text-primary-blue" />,
    integrations: [
      { name: "Mailchimp", logo: "/integrations/mailchimp.png" },
      { name: "Marketo", logo: "/integrations/marketo.png" },
    ]
  },
  {
    title: "Payment Processing",
    icon: <CreditCard className="h-6 w-6 text-primary-blue" />,
    integrations: [
      { name: "Stripe", logo: "/integrations/stripe.png" },
      { name: "PayPal", logo: "/integrations/paypal.png" },
    ]
  },
  {
    title: "E-commerce",
    icon: <ShoppingBag className="h-6 w-6 text-primary-blue" />,
    integrations: [
      { name: "Shopify", logo: "/integrations/shopify.png" },
      { name: "WooCommerce", logo: "/integrations/woocommerce.png" },
      { name: "BigCommerce", logo: "/integrations/bigcommerce.png" },
    ]
  },
  {
    title: "Data & Analytics",
    icon: <Database className="h-6 w-6 text-primary-blue" />,
    integrations: [
      { name: "QuickBooks", logo: "/integrations/quickbooks.png" },
      { name: "Google Sheets", logo: "/integrations/google-sheets.png" },
    ]
  }
];

const IntegrationsShowcase: React.FC = () => {
  return (
    <section className="py-16 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-primary-blue mb-4">
            Seamless Integrations
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Connect your favorite tools and services to streamline your referral program management
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {integrationCategories.map((category, index) => (
            <Card key={index} className="bg-white hover:shadow-lg transition-shadow">
              <CardHeader>
                <CardTitle className="flex items-center gap-2">
                  {category.icon}
                  <span>{category.title}</span>
                </CardTitle>
              </CardHeader>
              <CardContent>
                <div className="grid grid-cols-2 gap-4">
                  {category.integrations.map((integration, idx) => (
                    <div 
                      key={idx}
                      className="flex items-center gap-2 p-2 rounded-lg border border-gray-100 bg-gray-50"
                    >
                      <img 
                        src={integration.logo} 
                        alt={`${integration.name} logo`}
                        className="w-6 h-6 object-contain"
                      />
                      <span className="text-sm text-gray-700">{integration.name}</span>
                    </div>
                  ))}
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default IntegrationsShowcase;
